module.exports = __webpack_public_path__ + "img/soctio_logo_blue.696d4841.svg";